import { render, staticRenderFns } from "./index.vue?vue&type=template&id=db046838&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=db046838&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db046838",
  null
  
)

export default component.exports